import {Button, Col, Row} from "react-bootstrap";
import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import {toast} from "react-toastify";
import {
  TYPE_KE_HOACH_DAO_TAO
} from "../../../../quan-ly-khao-sat/Components/danh-sach-ke-hoach/constants/constansKeHoach";
import TableNhanLuc from "./TableNhanLuc";
import LabelRequired from "../../../../component/LabelRequired";
import TextField from "../../../../component/TextField";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";
import {getListCoSoVatChat} from "../services/services";
import {MAX_PAGE_SIZE} from "../../../../utils/Constant";

interface Props {
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>;
  dataTrangThietBi: any[];
  setDataTrangThietBi: Dispatch<SetStateAction<any[]>>;
  isView?: boolean;
}

const CoSoVatChat = (props: Props) => {
  const {dataTrangThietBi, setDataTrangThietBi, isView} = props;

  const [selectedCoSoVatChat, setSelectedCoSoVatChat] = useState<any>(null);
  const [yeuCauThiThuat, setYeuCauThiThuat] = useState<string>('');
  const [nhapTrongTenTaiDay, setNhapTrongTenTaiDay] = useState<string>('');
  const [ghiChu, setGhiChu] = useState<string>('');
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  // const [dsCoSoVatChat] = useState<any>([
  //     {"id": 1, "name": "Giường bệnh"},
  //     {"id": 2, "name": "Buồng bệnh / phòng điều trị"},
  //     {"id": 3, "name": "Diện tích sàn khu vực thực hiện kỹ thuật"},
  //     {"id": 4, "name": "Phòng thủ thuật / phòng mổ"},
  //     {"id": 5, "name": "Hệ thống điện và điện dự phòng"},
  //     {"id": 6, "name": "Hệ thống nước sạch"},
  //     {"id": 7, "name": "Hệ thống khí y tế (oxy – hút)"},
  //     {"id": 8, "name": "Hệ thống vệ sinh – rửa tay"},
  //     {"id": 9, "name": "Kiểm soát nhiễm khuẩn"},
  //     {"id": 10, "name": "Internet / mạng nội bộ"}
  //   ]
  // );
  const [dsCoSoVatChat, setDsCoSoVatChat] = useState<any>([
  ]);

  const getListData = async () => {
    try {
      const data = await getListCoSoVatChat({pageSize: MAX_PAGE_SIZE})
      setDsCoSoVatChat(data?.data?.data?.content ?? [])
    } catch (e) {

    }
  }

  useEffect(() => {
    getListData()
  }, [])

  const handleAddOrUpdate = () => {
    if (!selectedCoSoVatChat || !yeuCauThiThuat) {
      toast.warning('Vui lòng điền đầy đủ thông tin bắt buộc');
      return;
    }

    const newItem = {
      coSoVatChat: selectedCoSoVatChat.id,
      coSoVatChatName: selectedCoSoVatChat.name,
      yeuCauThiThuat,
      nhapTrongTenTaiDay,
      ghiChu
    };

    if (editingIndex !== null) {
      const updatedList = [...dataTrangThietBi];
      updatedList[editingIndex] = newItem;
      setDataTrangThietBi(updatedList);
      setEditingIndex(null);
      toast.success('Cập nhật thành công');
    } else {
      setDataTrangThietBi([newItem, ...dataTrangThietBi]);
      toast.success('Thêm thành công');
    }

    setSelectedCoSoVatChat(null);
    setYeuCauThiThuat('');
    setNhapTrongTenTaiDay('');
    setGhiChu('');
  };

  const handleEdit = (row: any, index: number) => {
    setSelectedCoSoVatChat({id: row.coSoVatChat, name: row.coSoVatChatName});
    setYeuCauThiThuat(row.yeuCauThiThuat || '');
    setNhapTrongTenTaiDay(row.nhapTrongTenTaiDay || '');
    setGhiChu(row.ghiChu || '');
    setEditingIndex(index);
  };

  const handleDelete = (index: number) => {
    const updatedList = dataTrangThietBi.filter((_: any, i: number) => i !== index);
    setDataTrangThietBi(updatedList);
    toast.success('Xóa thành công');
  };

  const columnsDkDaoTao = [
    {
      name: "STT",
      field: "",
      headerStyle: {width: 80},
      cellStyle: {textAlign: "center"},
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView
      ? [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {width: 100},
          cellStyle: {textAlign: "center", justifyContent: "center"},
          render: (row: any, index: number) => (
            <div className="d-flex justify-content-center">
              <i
                onClick={() => handleEdit(row, index)}
                className="bi bi-pencil-square text-navy cursor-pointer"
                style={{cursor: 'pointer', marginRight: '10px'}}
              ></i>
              <i
                onClick={() => handleDelete(index)}
                className="bi bi-trash3-fill text-danger cursor-pointer"
                style={{cursor: 'pointer'}}
              ></i>
            </div>
          ),
        },
      ]
      : []),
    {
      name: "Cơ sở vật chất",
      field: "coSoVatChatName",
      headerStyle: {minWidth: 200},
      cellStyle: {textAlign: "left"},
      render: (row: any) => row.coSoVatChatName || '',
    },
    {
      name: "Yêu cầu thi thoát",
      field: "yeuCauThiThuat",
      headerStyle: {minWidth: 200},
      cellStyle: {textAlign: "left"},
      render: (row: any) => row.yeuCauThiThuat || '',
    },
    {
      name: "Ghi chú",
      field: "ghiChu",
      headerStyle: {minWidth: 150},
      cellStyle: {textAlign: "left"},
      render: (row: any) => row.ghiChu || '',
    },
  ];

  return (
    <div className="">
      <div className="spaces mt-10 title">
        <span className="text-title fw-bold fs-5 spaces mb-5 mt-20">
          Cơ sở vật chất
        </span>
      </div>
      <Row>
        <Col lg={1} className="spaces">
          <div className="spaces pt-10">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Cơ sở vật chất"/>
            </div>
          </div>
        </Col>
        <Col lg={5} className="spaces pt-8 pl-36">
          <AutocompleteObjectV2
            options={dsCoSoVatChat}
            value={selectedCoSoVatChat}
            isSearchDefauilt={true}
            name="coSoVatChat"
            onChange={(options: any) => setSelectedCoSoVatChat(options)}
            className="autocomplete-custom-renderform radius spaces width-100 h-29"
            isClearable={true}
            disabled={isView}
          />
        </Col>
        <Col lg={1} className="spaces">
          <div className="spaces pt-10">
            <div className="spaces min-w-135 mt-1">
              <LabelRequired className="min-w-100px" label="Yêu cầu thi thoát"/>
            </div>
          </div>
        </Col>
        <Col lg={5} className="spaces pt-8 pl-36">
          <TextField
            name="yeuCauThiThuat"
            type="text"
            onChange={(e: any) => setYeuCauThiThuat(e.target.value)}
            value={yeuCauThiThuat}
            disabled={isView}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col lg={1} className="spaces">
          <div className="spaces pt-10">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Ghi chú"/>
            </div>
          </div>
        </Col>
        <Col lg={11} className="spaces pt-8 pl-36">
          <TextField
            name="ghiChu"
            type="text"
            onChange={(e: any) => setGhiChu(e.target.value)}
            value={ghiChu}
            disabled={isView}
          />
        </Col>
      </Row>
      {!isView && (
        <div className="flex mt-10 spaces items-center">
          <Button
            className="btn-fill spaces min-w-90px btn btn-primary"
            onClick={handleAddOrUpdate}
            type="button"
          >
            <i className="bi bi-plus-lg text-pri fs-3"></i>
            {editingIndex !== null ? 'Cập nhật' : 'Thêm'}
          </Button>
          {editingIndex !== null && (
            <Button
              className="btn-fill spaces min-w-90px btn btn-secondary ml-2"
              onClick={() => {
                setEditingIndex(null);
                setSelectedCoSoVatChat(null);
                setYeuCauThiThuat('');
                setNhapTrongTenTaiDay('');
                setGhiChu('');
              }}
              type="button"
            >
              Hủy
            </Button>
          )}
        </div>
      )}
      <TableNhanLuc
        columns={columnsDkDaoTao}
        isView={isView}
        dsItems={dataTrangThietBi ?? []}
      />
    </div>
  );
};

export default CoSoVatChat;